import { IContent } from 'models/content.model';

export const content: IContent = {
  nl: {
    mask: 'NL 02 ABNA 0123 4567 8901 2345 6789 1234 56',
    placeholder: 'Voorbeeld van een IBAN: NL 02 ABNA 0123 4567 89',
  },
  en: {},
};
